export const AUTH_ONLY_MANAGER = "AUTH_ONLY_MANAGER";
export const AUTH_ONLY_CUSTOMER = "AUTH_ONLY_CUSTOMER";
export const NOT_IE = "NOT_IE";
